import type { RequestMessage, ResponseMessage } from './messages';

export type ProcedureExecutor<Req, Res> = (request: Req) => Res | Promise<Res>;

export async function processRequest(
  procedures: Partial<Record<string, ProcedureExecutor<any, any>>>,
  request: RequestMessage<string, unknown>,
): Promise<ResponseMessage<string, unknown>> {
  const { jobID, procedure } = request;
  try {
    const payload = await procedures[procedure](request.payload);
    return { jobID, ok: true, procedure, payload };
  } catch (e) {
    const responseError = (e as any)?.error;
    const backendMessage =
      responseError?.message ??
      responseError?.error ??
      (Array.isArray(responseError) ? responseError[0] : undefined);

    const error =
      typeof e === 'string'
        ? e
        : e instanceof Error
          ? e.message
          : typeof backendMessage === 'string'
            ? backendMessage
            : typeof (e as any)?.message === 'string'
              ? (e as any).message
              : undefined;

    return { error, jobID, ok: false, procedure };
  }
}
